var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.viewDebugElements)?_c('v-card',{attrs:{"color":"#385F73","dark":""}},[(_vm.label)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_c('v-card-title',[_vm._v(" Debug ")]),_c('v-card-text',[_c('pre',[_vm._t("default")],2)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }